import { useTranslation } from "react-i18next";
import { THeaderV2Props } from "../../header-v2";
import styles from "./mobile-header.module.less";
import { useEffect, useState } from "react";
import MobileFoldupMenu from "../mobile-foldup-menu/mobile-foldup-menu";
import EventAggregator from "../../../../../events/event-aggregator";
import { LinkWrapper } from "../../../../elements";

const MobileHeader = ({
  featureLinks,
  menuItems,
  mobileHeaderLinks,
  disableBoxShadowMobile = false,
}: THeaderV2Props) => {
  const { t } = useTranslation();

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const onRouteUpdateEvent = EventAggregator.subscribe("onRouteUpdate", () => {
      setIsMenuOpen(false);
    });

    return () => {
      onRouteUpdateEvent.remove();
    };
  }, []);

  return (
    <nav
      className={[styles.wrapper, disableBoxShadowMobile ? styles.disableBoxShadow : ""].join(" ")}
      aria-label={t("HEADER_MENU_MOBILE_ARIA_LABEL")}
    >
      {mobileHeaderLinks?.map((mobileLink, index) => (
        <LinkWrapper url={mobileLink.url} key={index} className={`${styles.menuButton} dynamicIcons`}>
          <span className={[styles.icon, mobileLink.icon, "default"].join(" ")} />
          <span className={[styles.icon, mobileLink.icon + "-filled", "currentPage hover"].join(" ")} />
          <div className={["body-s mb-0", styles.title].join(" ")}>{mobileLink.title}</div>
        </LinkWrapper>
      ))}
      <button className={styles.menuButton} onClick={() => setIsMenuOpen(true)}>
        <span className={[styles.icon, "ui-icon-menu-bold"].join(" ")} />
        <div className={["body-s mb-0", styles.title].join(" ")}>{t("HEADER_MENU")}</div>
      </button>
      <MobileFoldupMenu
        featureLinks={featureLinks}
        menuItems={menuItems}
        isOpen={isMenuOpen}
        onClickClose={() => {
          setIsMenuOpen(false);
        }}
        portalContainer={typeof document !== "undefined" ? document.getElementById("mobile-menu-portal") : null}
      />
      <div id="mobile-menu-portal" />
    </nav>
  );
};

export default MobileHeader;
